import useRepo from '@/nebula/repo';
import { COUNT, RESULT } from 'shared/api/query/constants';
import { goalChange as goalChangeConfig } from 'shared/api/query/configs.json';
import { goalChangeList, goalChangesByIds } from '@/api/query/nebula/goal-change';
import { injectExclusionFilter } from 'shared/api/query/exclusion-filter';

export const GOAL_CHANGES_PER_PAGE = 20;
export const GOAL_CHANGE_HISTORY_DAYS = 90;
export const GOAL_CHANGE_RECORDING_START = new Date('2026-10-22T16:50:34Z');
export const GOAL_CHANGE_REFRESH_DELAY = 1500;

export const goalChangeWindowStart = () => new Date(Date.now() - GOAL_CHANGE_HISTORY_DAYS * 24 * 60 * 60 * 1000);

export default function useGoalChangeRepo() {
  const repo = useRepo(goalChangeConfig.model);

  const getList = ({ goalId, excludedIds = [], since = goalChangeWindowStart() }) => repo
    .query(injectExclusionFilter(goalChangeList({
      goalId,
      since,
      pagination: { page: 1, itemsPerPage: GOAL_CHANGES_PER_PAGE, countAlias: COUNT },
    }), excludedIds, goalChangeConfig.model)).then((response) => ({
      goalChanges: repo.selectMultiple(response[RESULT].map((c) => c.uid)),
      count: response[COUNT][0].count,
    }));

  const getByIds = ({ goalId, ids }) => repo
    .query(goalChangesByIds({ goalId, ids }))
    .then((response) => repo.selectMultiple(response[RESULT].map((c) => c.uid)));

  const changesOf = (goalId) => repo.entityList.value.filter((c) => String(c.goal?.uid) === String(goalId));

  const removeLocally = (ids) => repo.deleteMultiple(ids, { commitToRemote: false });

  return { getList, getByIds, changesOf, removeLocally };
}
